module.exports = __webpack_public_path__ + "static/media/hand-pointer.eeabcc7b.svg";